import React from 'react';

import Box from '@material-ui/core/Box';
import LinearProgress from '@material-ui/core/LinearProgress';
import Typography from '@material-ui/core/Typography';

/**
 * Barra de progresso com o percentual à direita.
 *
 * Mesmo componente que já existia como helper local em NewFund.js e em
 * SuitabilityQuestionaryModal.js — extraído aqui para ser reaproveitado por novos
 * fluxos de processamento em lote.
 *
 * @param {number} value percentual de 0 a 100
 */
export default function MyLinearProgressWithLabel(props) {

    return (
        <Box display="flex" alignItems="center" width="100%">
            <Box width="100%" mr={1}>
                <LinearProgress variant="determinate" {...props} />
            </Box>
            <Box minWidth={35}>
                <Typography variant="body2" color="textSecondary">
                    {`${Math.round(props.value)}%`}
                </Typography>
            </Box>
        </Box>
    );
}
